{{each list}}
<div class="dynamin-list-block {{if level == 1}} _commentLevelOne{{else if level ==2 }} _commentLevelThree {{/if}}">
    <a href="/user/index?uid={{$value.uid}}">
    <div class="dynamin-head">
        <img src="{{$value.user.avatar}}" alt="{{$value.user.real_name}}">
    </div>
    </a>
    <div class="dynamin-content">
        <p class="dynamin-nikeName">{{$value.user.real_name}}<span>{{$value.user.career}}</span><span>{{$value.ctime}}</span></p>
        <p class="dynamin-title">
            {{@ $value.content}}
        </p>
        <p class=" hide-show-comment _hideShowAllComment hide">展开</p>
        <div class="dynamin-options">
            <span class="_thumbBtn {{if $value.is_support == 1}} _hasThumbs {{/if}}" data-id="{{$value.id}}">
                <i class="icon iconfont icon-dianzan {{if $value.is_support == 1}} active {{/if}}"></i>
                <em  data-count="{{$value.support_count}}" class="_currThumbCount">
                {{if $value.support_count >0}}
                    {{$value.support_count}}
                {{else}}
                    点赞
                {{/if}}
               </em>
            </span>
            {{if level == 1}}
                {{if uid == $value.uid}}

                <span class="_getSecondLevel" data-id="{{$value.id}}">
                    <em class="_secondLevelCount">{{$value.comment_count}}</em>条评论
                </span>
                <span class="_deleteCommentBtn" data-level="2" data-id="{{$value.id}}">
                    <i class="icon iconfont icon-shanchu"></i>删除
                </span>
                <span class="_replyBtn reply-btn" data-level="2" data-pid="{{$value.pid}}" data-fromid="{{$value.from_id}}" data-id="{{$value.id}}">
                    <i class="icon iconfont icon-pinglun"></i>回复
                </span>
                {{else}}
                <span class="_getSecondLevel" data-id="{{$value.id}}">
                    <em class="_secondLevelCount">{{$value.comment_count}}</em>条评论
                </span>
                <span class="_showReportBtn jubao-box" data-id="{{$value.id}}">
                <i class="icon iconfont icon-jubao"></i>举报
                </span>
                <span class="_replyBtn reply-btn" data-level="2" data-pid="{{$value.pid}}" data-fromid="{{$value.from_id}}" data-id="{{$value.id}}">
                    <i class="icon iconfont icon-pinglun"></i>回复
                </span>
                {{/if}}
            {{else if level ==2}}

                {{if uid == $value.uid}}
                <span class="_deleteCommentBtn" data-pid="{{$value.id}}" data-fromid="{{$value.from_id}}" data-level="3" data-id="{{$value.id}}">删除</span>
                {{else if uid == $value.reply_uid}}
                <span class="_deleteCommentBtn" data-level="3"  data-id="{{$value.id}}">
                    <i class="icon iconfont icon-shanchu"></i>删除
                </span>
                <span class="_showReportBtn jubao-box" data-id="{{$value.id}}">
                <i class="icon iconfont icon-jubao"></i>举报
                </span>
                <span class="_replyBtn reply-btn" data-level="3" data-pid="{{$value.id}}" data-fromid="{{$value.from_id}}" data-id="{{$value.id}}">
                    <i class="icon iconfont icon-pinglun"></i>回复
                </span>
                {{else}}
                <span class="_showReportBtn jubao-box" data-id="{{$value.id}}">
                <i class="icon iconfont icon-jubao"></i>举报
                </span>
                <span class="_replyBtn reply-btn" data-level="3" data-pid="{{$value.id}}" data-fromid="{{$value.from_id}}" data-id="{{$value.id}}">
                    <i class="icon iconfont icon-pinglun"></i>回复
                </span>
                {{/if}}
            {{/if}}
        </div>
    </div>
    {{if level == 1}}
    <div class="comment-level-2 _commentLevelTwo">
        <div class="_commentLevelTwoInput"></div>
        <div class="_commentLevelTwoList"></div>
    </div>
    {{else}}
    <div class="comment-level-2 _commentLevelThreeInput" style="display: none">
    </div>
    {{/if}}
</div>
{{/each}}
